import { render, staticRenderFns } from "./acctInfoPwdModify.vue?vue&type=template&id=b5e2d8fc&scoped=true"
import script from "./acctInfoPwdModify.vue?vue&type=script&lang=js"
export * from "./acctInfoPwdModify.vue?vue&type=script&lang=js"
import style0 from "./acctInfoPwdModify.vue?vue&type=style&index=0&id=b5e2d8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e2d8fc",
  null
  
)

export default component.exports